/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericGetPresignedUrl} from '../api'

export const useMutationGenericGetPresignedUrl = createReactQueryMutationHook('genericGetPresignedUrl', genericGetPresignedUrl)
